import { formatInTimeZone } from "date-fns-tz";

/**
 * Formats a proposal ISO timestamp as dd/MM/yyyy in UTC, for the backoffice
 * proposal-management screens (list/detail).
 */
export const formatProposalDate = (iso: string | undefined | null): string => {
  if (!iso) {
    return "—";
  }

  const timestamp = Date.parse(iso);
  if (Number.isNaN(timestamp)) {
    return "—";
  }

  return formatInTimeZone(iso, "UTC", "dd/MM/yyyy");
};
